import * as Blockly from 'blockly/core';
import 'blockly/python';
import {getAllowedStatements} from "./strata_compatibility_checks";
import createCustomThresholdFields from "./strata_custom_threshold_fields";

Blockly.Blocks['strata_pred_indicator'] = {
    init: function () {
        this.appendDummyInput()
            .setAlign(Blockly.ALIGN_LEFT)
            .appendField("Climate Projection Indicator   ")
            .appendField(new Blockly.FieldDropdown([
                ["Temperature (future)", "temp"],
                ["Precipitation (future)", "rainfall"],
                ["Flood likelihood (future)", "flood"]
            ]), "indicator_selection");
        createCustomThresholdFields(this);

        this.setPreviousStatement(true, 'predictive_indicators');
        this.setNextStatement(true, getAllowedStatements('predictive_indicators'));
        this.setStyle('environment_indicator') //same colour as environment blocks for now 
        this.setTooltip("");
        this.setHelpUrl("");
    }
}
